import { render } from "./Qualification.vue?vue&type=template&id=48f0d5f4&scoped=true"
import script from "./Qualification.vue?vue&type=script&lang=js"
export * from "./Qualification.vue?vue&type=script&lang=js"

import "./Qualification.vue?vue&type=style&index=0&id=48f0d5f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f0d5f4"]])

export default __exports__